import React from 'react'
import { formatCurrenctyWithoutSignal } from 'utils'
import './style.scss'

export function CartMonthlyValue({ value, isPrimary = false }) {
  return (
    <span className={`cart-value-container ${isPrimary ? '-primary' : ''}`}>
      R$
      <span className='value'>{formatCurrenctyWithoutSignal(value)}</span>
      /mês
    </span>
  )
}
